import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ClinicUserGroupsTable } from "../../../components/clinic-user-groups/ClinicUserGroupsTable";
import { useEffect } from "react";

const ClinicUserGroups = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Clinic User Groups | Admin";
  }, []);

  const handleAddNew = () => {
    navigate("/admin/clinic-user-groups/add");
  };

  return (
    <div id="clinic_user_groups_page_container" className="space-y-6">
      <header className="space-y-4">
        <div>
          <h1 id="clinic_user_groups_page_title" className="text-3xl font-bold text-foreground">Clinic User Groups</h1>
          <p className="text-muted-foreground">Manage clinic user groups</p>
        </div>
        <div className="flex justify-end">
          <Button id="clinic_user_groups_page_add_btn" onClick={handleAddNew} className="bg-yellow-400 hover:bg-yellow-500 text-black">
            <Plus className="h-4 w-4" />
            Add New Clinic User Group
          </Button>
        </div>
      </header>

      <main id="clinic_user_groups_page_main">
        <ClinicUserGroupsTable />
      </main>
    </div>
  );
};

export default ClinicUserGroups;
